import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as o } from "react";
import { I as t } from "../../../../IconBase-CxZyIWw2.js";
const i = o((e, r) => /* @__PURE__ */ s.jsx(
  t,
  {
    ref: r,
    ...e,
    image: (a) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...a,
        children: [
          /* @__PURE__ */ s.jsx(
            "mask",
            {
              id: "mask0_2974_3536",
              width: 16,
              height: 12,
              x: 0,
              y: 3,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: /* @__PURE__ */ s.jsx(
                "path",
                {
                  fill: "currentColor",
                  d: "M7.25 13H.75c-.41 0-.75.34-.75.75s.34.75.75.75h6.5c.41 0 .75-.34.75-.75S7.66 13 7.25 13M15.25 8H.75C.34 8 0 8.34 0 8.75s.34.75.75.75h14.5c.41 0 .75-.34.75-.75S15.66 8 15.25 8M.75 4.5h14.5c.41 0 .75-.34.75-.75S15.66 3 15.25 3H.75C.34 3 0 3.34 0 3.75s.34.75.75.75"
                }
              )
            }
          ),
          /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_3536)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) })
        ]
      }
    )
  }
));
i.displayName = "AgencyMenuIcon";
export {
  i as AgencyMenuIcon,
  i as default
};
//# sourceMappingURL=index.js.map
